import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const SECTIONS = [
  {
    n: "1",
    t: "IDENTIDAD Y DOMICILIO DEL RESPONSABLE",
    p: [
      "Flodelica Fiscal (en adelante, \"EL RESPONSABLE\") es responsable del tratamiento y protección de sus datos personales, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), su Reglamento y demás normatividad aplicable.",
      "EL RESPONSABLE tiene su domicilio en Calle 32 Ext. 269, Colonia Montes de Amé, Mérida, Yucatán, C.P. 97115, México.",
      "Para cualquier asunto relacionado con el presente Aviso de Privacidad, EL RESPONSABLE pone a disposición los siguientes medios de contacto: correo electrónico info@flodelicafiscal.com y teléfono +52 999 592 7397.",
    ],
  },
  {
    n: "2",
    t: "DATOS PERSONALES QUE SE RECABAN",
    p: ["Para las finalidades señaladas en el presente Aviso, EL RESPONSABLE podrá recabar los siguientes datos personales:"],
    list: [
      "Datos de identificación: nombre completo, país y empresa.",
      "Datos de contacto: correo electrónico y número telefónico.",
      "Datos derivados de la contratación: información fiscal, contable, financiera y administrativa proporcionada voluntariamente por EL CLIENTE.",
      "Datos de pago: los necesarios para procesar honorarios a través de los medios autorizados.",
    ],
    p2: ["EL RESPONSABLE no recaba datos personales sensibles de manera intencional a través del sitio web."],
  },
  {
    n: "3",
    t: "FINALIDADES DEL TRATAMIENTO",
    p: ["Finalidades primarias (necesarias para la relación jurídica):"],
    list: [
      "Atender solicitudes de información y contacto.",
      "Elaborar propuestas comerciales y cotizaciones.",
      "Prestar los servicios profesionales contratados.",
      "Procesar y verificar pagos.",
      "Dar cumplimiento a obligaciones legales, fiscales y contractuales.",
    ],
    p2: ["Finalidades secundarias (no necesarias, que puede rechazar):"],
    list2: [
      "Envío de comunicaciones informativas y comerciales.",
      "Elaboración de estadísticas y mejora de nuestros servicios.",
    ],
    p3: ["Si no desea que sus datos se traten para las finalidades secundarias, puede manifestarlo enviando un correo a info@flodelicafiscal.com. Su negativa no será motivo para negarle los servicios contratados."],
  },
  {
    n: "4",
    t: "TRANSFERENCIA DE DATOS",
    p: [
      "EL RESPONSABLE no transferirá sus datos personales a terceros sin su consentimiento, salvo en los casos previstos por el artículo 37 de la LFPDPPP (por ejemplo, cuando la transferencia sea necesaria por virtud de una ley, para el cumplimiento de obligaciones contractuales, o requerida por autoridad competente).",
      "En caso de utilizar proveedores de servicios (como plataformas de pago o herramientas tecnológicas), estos actuarán como encargados y tratarán los datos únicamente conforme a las instrucciones del RESPONSABLE.",
    ],
  },
  {
    n: "5",
    t: "DERECHOS ARCO",
    p: [
      "Usted tiene derecho a Acceder, Rectificar y Cancelar sus datos personales, así como a Oponerse al tratamiento de los mismos o revocar el consentimiento otorgado (Derechos ARCO).",
      "Para ejercer cualquiera de estos derechos, deberá enviar una solicitud al correo info@flodelicafiscal.com, indicando: (i) su nombre y medio para recibir respuesta; (ii) documento que acredite su identidad; (iii) descripción clara de los datos y del derecho que desea ejercer.",
      "EL RESPONSABLE dará respuesta a su solicitud en los plazos establecidos por la LFPDPPP.",
    ],
  },
  {
    n: "6",
    t: "REVOCACIÓN DEL CONSENTIMIENTO",
    p: ["Usted puede revocar en cualquier momento el consentimiento otorgado para el tratamiento de sus datos personales. Sin embargo, la revocación podría implicar la imposibilidad de continuar con la prestación del servicio contratado o la conclusión de la relación con EL RESPONSABLE."],
  },
  {
    n: "7",
    t: "USO DE COOKIES Y TECNOLOGÍAS DE RASTREO",
    p: ["El sitio web podrá utilizar cookies y tecnologías similares para mejorar la experiencia de navegación y obtener estadísticas de uso. Usted puede deshabilitarlas desde la configuración de su navegador, entendiendo que ello podría afectar el funcionamiento del sitio."],
  },
  {
    n: "8",
    t: "MEDIDAS DE SEGURIDAD",
    p: ["EL RESPONSABLE ha implementado medidas de seguridad administrativas, técnicas y físicas razonables para proteger sus datos personales contra daño, pérdida, alteración, destrucción o uso, acceso o tratamiento no autorizados."],
  },
  {
    n: "9",
    t: "MODIFICACIONES AL AVISO DE PRIVACIDAD",
    p: ["EL RESPONSABLE se reserva el derecho de efectuar en cualquier momento modificaciones al presente Aviso de Privacidad. Dichas modificaciones estarán disponibles a través del sitio web, por lo que se recomienda su consulta periódica."],
  },
  {
    n: "10",
    t: "CONSENTIMIENTO",
    p: ["Al proporcionar sus datos personales a través del sitio web, formularios, correo electrónico, WhatsApp o cualquier otro medio, y al contratar nuestros servicios, usted manifiesta su consentimiento para el tratamiento de sus datos conforme a lo establecido en el presente Aviso de Privacidad."],
  },
];

export const PrivacyModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl bg-[#0A0A0B] border border-white/10 text-white p-0 gap-0 max-h-[85vh] flex flex-col"
        data-testid="privacy-modal"
      >
        <DialogHeader className="px-6 md:px-10 pt-8 pb-5 border-b border-white/10">
          <span className="flo-label text-gold mb-3 block">Flodelica Fiscal</span>
          <DialogTitle className="font-serif-display text-2xl md:text-3xl tracking-tight text-white text-left">
            Aviso de Privacidad
          </DialogTitle>
          <DialogDescription className="text-zinc-500 text-left text-xs mt-2">
            Última actualización: Julio de 2026
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-10 py-6" data-testid="privacy-scroll">
          <div className="space-y-8">
            <p className="text-zinc-400 leading-relaxed text-sm">
              En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, se
              pone a su disposición el presente Aviso de Privacidad, que describe cómo Flodelica Fiscal recaba, utiliza y
              protege sus datos personales.
            </p>

            {SECTIONS.map((s) => (
              <div key={s.n} className="space-y-3" data-testid={`privacy-section-${s.n}`}>
                <h3 className="font-serif-display text-lg md:text-xl text-white flex items-baseline gap-3">
                  <span className="text-gold text-sm">{s.n}.</span>
                  {s.t}
                </h3>
                {s.p?.map((para, i) => (
                  <p key={`p-${i}`} className="text-zinc-400 leading-relaxed text-sm">{para}</p>
                ))}
                {s.list && (
                  <ul className="space-y-1.5 pl-1">
                    {s.list.map((li, i) => (
                      <li key={`l-${i}`} className="text-zinc-400 text-sm flex gap-2">
                        <span className="mt-1.5 h-1 w-1 rounded-full bg-gold shrink-0" />
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
                {s.p2?.map((para, i) => (
                  <p key={`p2-${i}`} className="text-zinc-400 leading-relaxed text-sm">{para}</p>
                ))}
                {s.list2 && (
                  <ul className="space-y-1.5 pl-1">
                    {s.list2.map((li, i) => (
                      <li key={`l2-${i}`} className="text-zinc-400 text-sm flex gap-2">
                        <span className="mt-1.5 h-1 w-1 rounded-full bg-gold shrink-0" />
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
                {s.p3?.map((para, i) => (
                  <p key={`p3-${i}`} className="text-zinc-400 leading-relaxed text-sm">{para}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
